import { Crown, Mail, Phone, MapPin } from "lucide-react";
import { CONTACT } from "../config/contact";

export function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#0f1f3d] text-white relative overflow-hidden" role="contentinfo">
      {/* Slim brand hairline */}
      <div className="h-px bg-gradient-to-r from-transparent via-[#d4af37] to-transparent"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12 mb-12">
          {/* Brand Section */}
          <div className="space-y-4" itemScope itemType="https://schema.org/Organization">
            <a href="#" className="flex items-center gap-3 group" itemProp="url">
              <Crown className="w-10 h-10 text-[#d4af37]" aria-hidden="true" />
              <div>
                <span className="text-3xl text-white" itemProp="name">Majesty</span>
                <div className="text-xs tracking-wider text-[#d4af37]">HOSTEL</div>
              </div>
            </a>
            <p className="text-white/70 leading-relaxed" itemProp="description">
              Premium student accommodation offering comfort and a well-run living experience near campus in Koforidua, Ghana.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold mb-6 text-lg">Quick Links</h3>
            <ul className="space-y-3">
              {[
                { label: "Home", href: "#" },
                { label: "Facilities", href: "#facilities" },
                { label: "Gallery", href: "#gallery" },
                { label: "Contact", href: "#contact" },
              ].map((link, index) => (
                <li key={index}>
                  <a
                    href={link.href}
                    className="text-white/70 hover:text-[#d4af37] transition-colors duration-300 inline-flex items-center gap-2 group"
                  >
                    <span className="w-0 group-hover:w-2 h-0.5 bg-[#d4af37] transition-all duration-300"></span>
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-white font-semibold mb-6 text-lg">Contact Us</h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3 text-white/70 group">
                <div className="w-10 h-10 bg-white/5 rounded-lg flex items-center justify-center flex-shrink-0 group-hover:bg-[#d4af37]/20 transition-colors duration-300">
                  <MapPin className="w-5 h-5 text-[#d4af37]" aria-hidden="true" />
                </div>
                <div>
                  <p className="leading-relaxed">{CONTACT.address.full}</p>
                </div>
              </li>
              <li className="flex items-start gap-3 text-white/70 group">
                <div className="w-10 h-10 bg-white/5 rounded-lg flex items-center justify-center flex-shrink-0 group-hover:bg-[#d4af37]/20 transition-colors duration-300">
                  <Phone className="w-5 h-5 text-[#d4af37]" aria-hidden="true" />
                </div>
                <div>
                  {CONTACT.phones.map((phone) => (
                    <p key={phone}>{phone}</p>
                  ))}
                </div>
              </li>
              <li className="flex items-start gap-3 text-white/70 group">
                <div className="w-10 h-10 bg-white/5 rounded-lg flex items-center justify-center flex-shrink-0 group-hover:bg-[#d4af37]/20 transition-colors duration-300">
                  <Mail className="w-5 h-5 text-[#d4af37]" aria-hidden="true" />
                </div>
                <div>
                  <p>{CONTACT.emails.general}</p>
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/10">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-white/70 text-sm">
            <p>© {currentYear} Majesty Hostel. All rights reserved.</p>
            <p>Powered by Larnis Technologies</p>
          </div>
        </div>
      </div>
    </footer>
  );
}
